// ridiculous, but it's for fast refresh lol
export { default as APP_NAME } from './app-name'
export { default as APP_URL } from './app-url'
export const LEGAL_NAME = 'BeatGig, LLC'
